"use client";

import { useEffect, useState } from "react";

import {
  CONSENT_EVENT,
  consentChoice,
  consentRegion,
} from "@/lib/analytics-consent";

export interface AnalyticsConsentState {
  ready: boolean;
  required: boolean;
  choice: boolean | null;
}

export function useAnalyticsConsent(): AnalyticsConsentState {
  const [state, setState] = useState<AnalyticsConsentState>({
    ready: false,
    required: false,
    choice: null,
  });

  useEffect(() => {
    const read = () =>
      setState({
        ready: true,
        required: consentRegion(),
        choice: consentChoice(),
      });
    read();
    window.addEventListener(CONSENT_EVENT, read);
    return () => window.removeEventListener(CONSENT_EVENT, read);
  }, []);

  return state;
}
